
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./google-analytics.cjs.production.min.js')
} else {
  module.exports = require('./google-analytics.cjs.development.js')
}
